import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/layout/AppShell";
import { api, fmtEur, fmtDate } from "@/lib/api";

const STATUS = { active: ["Activa", "text-emerald-400 border-emerald-500/30"], canceled: ["Cancelada", "text-amber-400 border-amber-500/30"], refunded: ["Reembolsada", "text-red-400 border-red-500/30"] };

export default function Sales() {
  const { data = [], isLoading } = useQuery({ queryKey: ["sales"], queryFn: async () => (await api.get("/sales")).data });
  const gross = data.filter((s) => s.status !== "refunded").reduce((a, s) => a + (s.amount || 0), 0);
  const net = data.filter((s) => s.status !== "refunded").reduce((a, s) => a + (s.net || 0), 0);
  return (
    <div>
      <PageHeader eyebrow="Ingresos" title="Ventas" subtitle="Cada adquisición de tus agentes, en detalle." />
      <div className="space-y-8 px-6 py-10 lg:px-12">
        <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-3">
          {[["Ventas", data.length, "sales-count"], ["Bruto", fmtEur(gross), "sales-gross"], ["Neto (tras 15%)", fmtEur(net), "sales-net"]].map(([l, v, id]) => (
            <div key={l} className="bg-[#080808] p-6" data-testid={id}><p className="text-[11px] uppercase tracking-widest text-zinc-500">{l}</p><p className="mt-2 font-mono text-2xl font-semibold">{v}</p></div>
          ))}
        </div>
        {isLoading ? <div className="h-px bg-white/10 thinking-beam" /> : data.length === 0 ? (
          <div className="border border-dashed border-white/15 p-12 text-zinc-500" data-testid="sales-empty">Todavía no hay ventas. Publica un agente con precio para empezar a vender.</div>
        ) : (
          <div className="overflow-x-auto border border-white/10" data-testid="sales-table">
            <table className="w-full text-sm">
              <thead><tr className="border-b border-white/10 text-left text-[11px] uppercase tracking-widest text-zinc-500">{["Fecha", "Agente", "Comprador", "Tipo", "Importe", "Neto", "Estado"].map((h) => <th key={h} className="px-5 py-3 font-semibold">{h}</th>)}</tr></thead>
              <tbody>
                {data.map((s) => {
                  const [l, c] = STATUS[s.status] || [s.status, "text-zinc-400 border-white/10"];
                  return (
                    <tr key={s.purchase_id} className="border-b border-white/5 hover:bg-white/[0.02]" data-testid={`sale-row-${s.purchase_id}`}>
                      <td className="px-5 py-3 text-zinc-400">{fmtDate(s.created_at)}</td>
                      <td className="px-5 py-3 font-medium">{s.agent_name}</td>
                      <td className="px-5 py-3 text-zinc-400">{s.buyer_name}</td>
                      <td className="px-5 py-3 text-zinc-400">{s.pricing_type === "monthly" ? "Mensual" : s.pricing_type === "free" ? "Gratis" : "Único"}</td>
                      <td className="px-5 py-3 font-mono">{fmtEur(s.amount)}</td>
                      <td className="px-5 py-3 font-mono text-emerald-400">{fmtEur(s.net)}</td>
                      <td className="px-5 py-3"><span className={`border px-2 py-0.5 text-[11px] uppercase tracking-wider ${c}`}>{l}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
